export default __webpack_public_path__ + "static/media/ThinCircular.709be992.svg";